import { jsx as _jsx } from "react/jsx-runtime";
import { CalendarIcon, LayerGroupIcon, RouterIcon, RefrigeratorIcon, PawIcon, BoxTapedIcon, AtticIcon, BlockBrickIcon, HouseTreeIcon, SunHazeIcon, WindowFrameIcon, AirConditionerIcon, WaterLadderIcon, CameraCctvIcon, DigitalLockIcon, LightEmergencyOnIcon, HandsHoldingHeartIcon, VacuumIcon, KeyIcon, ClockIcon, UserGroupIcon, UserPlusIcon, LoveseatIcon, PiggyBankIcon, HandHoldingDollarIcon, UmbrellaBeachIcon, BathIcon, ToiletIcon, DoorClosedIcon, LightbulbIcon, FireplaceIcon, BalconyIcon, TerraceIcon, LoggiaIcon, CircleParkingCircleIcon, DumbbellIcon, HotTubPersonIcon, WashingMachineIcon, TvRetroIcon, ReceptionistIcon, CustodianIcon, PhonePlusIcon, SprinklerCeilingIcon, CheckCircleIcon, TruckIcon, UtensilsIcon, FloorPlanIcon, WheelchairIcon, ElevatorIcon, BedFrontIcon, BoxArchiveIcon, CropSimpleIcon, LeafIcon, CompassIcon, PushPinIcon, BellConciergeIcon, } from "@gemini/icons";
import { IconKeysEnum } from "@/types";
export const previewFeaturesMapIcon = {
    // General Facts
    [IconKeysEnum.availability]: _jsx(CalendarIcon, {}),
    [IconKeysEnum.rented]: _jsx(KeyIcon, {}),
    [IconKeysEnum.rentalTime]: _jsx(ClockIcon, {}),
    [IconKeysEnum.flatShare]: _jsx(UserGroupIcon, {}),
    [IconKeysEnum.maxPersons]: _jsx(UserPlusIcon, {}),
    [IconKeysEnum.floors]: _jsx(LayerGroupIcon, {}),
    [IconKeysEnum.furnished]: _jsx(LoveseatIcon, {}),
    [IconKeysEnum.investment]: _jsx(PiggyBankIcon, {}),
    [IconKeysEnum.heritageProtected]: _jsx(HandHoldingDollarIcon, {}),
    [IconKeysEnum.pets]: _jsx(PawIcon, {}),
    [IconKeysEnum.holidayRental]: _jsx(UmbrellaBeachIcon, {}),
    [IconKeysEnum.separateEntrance]: _jsx(DoorClosedIcon, {}),
    // Interior
    [IconKeysEnum.attic]: _jsx(AtticIcon, {}),
    [IconKeysEnum.cellar]: _jsx(BoxTapedIcon, {}),
    [IconKeysEnum.mezzanine]: _jsx(LayerGroupIcon, {}),
    [IconKeysEnum.bayWindow]: _jsx(WindowFrameIcon, {}),
    [IconKeysEnum.livingRoom]: _jsx(LoveseatIcon, {}),
    [IconKeysEnum.bathroom]: _jsx(BathIcon, {}),
    [IconKeysEnum.toilet]: _jsx(ToiletIcon, {}),
    [IconKeysEnum.entrance]: _jsx(DoorClosedIcon, {}),
    [IconKeysEnum.kitchen]: _jsx(RefrigeratorIcon, {}),
    [IconKeysEnum.floorCovering]: _jsx(BlockBrickIcon, {}),
    [IconKeysEnum.lighting]: _jsx(LightbulbIcon, {}),
    [IconKeysEnum.chimney]: _jsx(FireplaceIcon, {}),
    [IconKeysEnum.bedroom]: _jsx(BedFrontIcon, {}),
    [IconKeysEnum.diningRoomSpace]: _jsx(BellConciergeIcon, {}),
    // Exterior
    [IconKeysEnum.balcony]: _jsx(BalconyIcon, {}),
    [IconKeysEnum.terrace]: _jsx(TerraceIcon, {}),
    [IconKeysEnum.garden]: _jsx(HouseTreeIcon, {}),
    [IconKeysEnum.veranda]: _jsx(LoggiaIcon, {}),
    [IconKeysEnum.loggia]: _jsx(LoggiaIcon, {}),
    [IconKeysEnum.parking]: _jsx(CircleParkingCircleIcon, {}),
    [IconKeysEnum.window]: _jsx(WindowFrameIcon, {}),
    [IconKeysEnum.view]: _jsx(SunHazeIcon, {}),
    [IconKeysEnum.calm]: _jsx(LeafIcon, {}),
    [IconKeysEnum.Orientation]: _jsx(CompassIcon, {}),
    [IconKeysEnum.locationAtCorner]: _jsx(PushPinIcon, {}),
    // Amenities
    [IconKeysEnum.ac]: _jsx(AirConditionerIcon, {}),
    [IconKeysEnum.gym]: _jsx(DumbbellIcon, {}),
    [IconKeysEnum.internet]: _jsx(RouterIcon, {}),
    [IconKeysEnum.sauna]: _jsx(HotTubPersonIcon, {}),
    [IconKeysEnum.swimming]: _jsx(WaterLadderIcon, {}),
    [IconKeysEnum.tv]: _jsx(TvRetroIcon, {}),
    [IconKeysEnum.laundry]: _jsx(WashingMachineIcon, {}),
    // Security & Services
    [IconKeysEnum.assistedLiving]: _jsx(HandsHoldingHeartIcon, {}),
    [IconKeysEnum.houseCleaningService]: _jsx(VacuumIcon, {}),
    [IconKeysEnum.receptionist]: _jsx(ReceptionistIcon, {}),
    [IconKeysEnum.camera]: _jsx(CameraCctvIcon, {}),
    [IconKeysEnum.intercom]: _jsx(CameraCctvIcon, {}),
    [IconKeysEnum.custodian]: _jsx(CustodianIcon, {}),
    [IconKeysEnum.digitalLock]: _jsx(DigitalLockIcon, {}),
    [IconKeysEnum.emergencyCall]: _jsx(PhonePlusIcon, {}),
    [IconKeysEnum.alarm]: _jsx(LightEmergencyOnIcon, {}),
    [IconKeysEnum.fireSprinkler]: _jsx(SprinklerCeilingIcon, {}),
    [IconKeysEnum.fireAlarm]: _jsx(LightEmergencyOnIcon, {}),
    [IconKeysEnum.reinforcedDoor]: _jsx(DoorClosedIcon, {}),
    [IconKeysEnum.safe]: _jsx(BoxArchiveIcon, {}),
    // Commercial features
    [IconKeysEnum.isDivisible]: _jsx(CropSimpleIcon, {}),
    [IconKeysEnum.accessibleByTrucks]: _jsx(TruckIcon, {}),
    [IconKeysEnum.ventilation]: _jsx(CheckCircleIcon, {}),
    [IconKeysEnum.flexible]: _jsx(FloorPlanIcon, {}),
    [IconKeysEnum.restaurantSeats]: _jsx(UtensilsIcon, {}),
    [IconKeysEnum.verticalDoor]: _jsx(CheckCircleIcon, {}),
    [IconKeysEnum.overhead]: _jsx(CheckCircleIcon, {}),
    [IconKeysEnum.loadingDocks]: _jsx(CheckCircleIcon, {}),
    [IconKeysEnum.liftingPlatform]: _jsx(ElevatorIcon, {}),
    [IconKeysEnum.companyRestaurant]: _jsx(UtensilsIcon, {}),
    // Accessibility
    [IconKeysEnum.barrier]: _jsx(WheelchairIcon, {}),
    [IconKeysEnum.elevator]: _jsx(ElevatorIcon, {}),
};
